import { gql } from "@apollo/client";

export const GET_ALL_EVALUACIONES_BY_PACIENTE = gql`
query GetAllEvaluacionesByPaciente($idPaciente: Int!) {
    allEvaluacionesByPaciente(idPaciente: $idPaciente) {
        success
        error
        valorEsperado {
            idEvaluacion
            delegacion
            programa
            estadoRI
            idRI
        }
    }
}`;